import { ListPageSkeleton, SidePanelSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * 标签管理页面骨架。
 *
 * 真实结构：`flex gap-5 h-full min-h-0 items-stretch`
 * → 左：`Card h-full flex-1 min-w-45`（`CardHeader h-12` 标题「标签分类」+ 分类列表）
 * → 右：`flex-6`（标题行「标签列表」+ 新增标签按钮，其下 `TableCardLayout` 内筛选区 + `DataTable` 8 列 + 分页）。
 *
 * 右侧表格高度由 `TableCardLayout` 按容器计算，这里用 `h-full` + `flex-1 min-h-0` 包一层，保证卡片高度被限制在容器内。
 */
export function LabelManagementSkeleton() {
  return (
    <div className="flex h-full flex-col gap-5">
      <div className="flex h-full items-start gap-5">
        {/* 左侧标签分类 */}
        <SidePanelSkeleton
          widthClassName="flex-1 min-w-45"
          itemCount={8}
          itemHeight={36}
          className="rounded-xl"
        />

        {/* 右侧标签列表 */}
        <div className="flex h-full min-w-0 flex-col flex-6">
          <div className="flex w-full shrink-0 items-center justify-between pb-4">
            <Skeleton className="h-6 w-20" />
            <Skeleton className="h-9.5 w-22" />
          </div>
          <div className="min-h-0 flex-1 overflow-hidden">
            {/* 实测 8 列：勾选 + 标签名称/所属分类/素材数量/标签状态/创建人/创建时间/操作 */}
            <ListPageSkeleton columnCount={8} className="rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LabelManagementSkeleton;
